import { createFileRoute } from '@tanstack/react-router'
import { AuditorAuditEvidenceDetailRoutePage } from '@/components/auditor-center/AuditorAuditEvidenceDetailRoutePage'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/audit-evidence/$evidenceKind/$evidenceItemId',
)({
  staticData: {
    pageHeader: {
      title: 'Evidence Detail',
      customHeader: true,
      pad: false,
      scroll: false,
    },
  },
  component: AuditorAuditEvidenceDetailRoutePage,
})
